import React from "react";
import { isNil } from "lodash";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../theme/palette";
import { View } from "../View";

const useStyles = makeStyles(() => ({
  container: {
    padding: "0 0.4rem",
    height: "1.25rem",
    lineHeight: "1.25rem",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    background: "green",
    color: "white",
    marginBottom: "9px",
    position: "relative",
  },
  shape: {
    position: "absolute",
    width: "0.25rem",
    height: "0.25rem",
    borderWidth: "0 0.094rem 0.094rem 0",
    borderColor: "white",
    borderStyle: "solid",
    bottom: "0.125rem",
    right: "0.125rem",
  },
}));

export const ArtificialPostcodeLabel = ({ artificialPostcode, ...rest }) => {
  const styles = useStyles({ level: artificialPostcode.level });
  const isAllocated =
    !isNil(artificialPostcode.lat) && !isNil(artificialPostcode.lng);
  return (
    <View
      style={{
        background: isAllocated
          ? artificialPostcode.colour
          : palette.translucentBlack,
        color: isAllocated
          ? artificialPostcode?.textColour || palette.typography.white.high
          : palette.typography.white.high,
        display: "inline-block",
      }}
      className={styles.container}
      {...rest}
    >
      {artificialPostcode.postcode}
      <View className={styles.shape} />
    </View>
  );
};
